module.exports = __webpack_public_path__ + "static/img/004_komp.0cc7e7ad.jpg";